module.exports = __webpack_public_path__ + "img/ia02.e98dea44.png";